module.exports = __webpack_public_path__ + "static/media/aquamarinedp.ac10d40d.jpg";